import { system } from 'styled-system'

export const whiteSpace = system({
  whiteSpace: {
    property: 'whiteSpace',
    scale: 'whiteSpaces',
  },
})

export interface WhiteSpaceProps {
  whiteSpace?: 'break-spaces' | 'none' | 'normal' | 'nowrap' | 'pre' | 'pre-wrap' | 'pre-line' | 'break-spaces'
}
